<script setup lang="ts">
  import { Typo } from '@travelata-libs/ui-kit';
  import LeadBannerAvatars from './LeadBannerAvatars.vue';

  interface LeadBannerSuccessProps {
    subtitle: string;
  }

  defineProps<LeadBannerSuccessProps>();

  const SUCCESS_TITLE_TEXT = 'Готово, ждите звонка';
</script>

<template>
  <div class="tl-lead-banner-success" data-test-id="lead-banner-success">
    <LeadBannerAvatars :count="3" size="l" centered :mobile="false" />

    <div class="tl-lead-banner-success__text">
      <Typo variant="h-5" class="tl-lead-banner-success__title">{{ SUCCESS_TITLE_TEXT }}</Typo>
      <Typo variant="body-l-400" class="tl-lead-banner-success__subtitle">{{ subtitle }}</Typo>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .tl-lead-banner-success {
    align-items: center;
    display: flex;
    gap: var(--spacing-m);
    justify-content: center;
    max-width: 782px;
    width: 100%;

    &__title {
      margin-bottom: var(--spacing-xxs);
    }

    &__subtitle {
      max-width: 380px;
    }
  }
</style>
